import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export const ThanksPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Thanks Section */}
      <section className="pt-20 pb-20 bg-gradient-to-br from-blue-50 to-slate-50 min-h-screen flex items-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Card className="p-12 shadow-xl border-0">
            <CardContent className="space-y-8">
              <div className="text-green-600 mb-6">
                <CheckCircle className="w-20 h-20 mx-auto" />
              </div>
              
              <h1 className="text-5xl font-bold text-navy-900 mb-6">Thank You!</h1>
              
              <div className="space-y-6">
                <p className="text-2xl text-gray-700 leading-relaxed">
                  Check your email for confirmation
                </p>
                
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  We've received your request and will get back to you within 24 hours. 
                  If you've booked a consultation, you should receive a calendar confirmation shortly.
                </p>
                
                <p className="text-base text-gray-500">
                  In the meantime, feel free to explore our services and expertise to learn more about how we can help strengthen your GMP compliance.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
                <a 
                  href="/"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
                >
                  Return to Homepage
                </a>
                <a 
                  href="/services"
                  className="border-2 border-blue-600 text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-lg font-semibold transition-colors duration-200"
                >
                  View Our Services
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      <Footer />
    </div>
  );
};